// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"BuyerAssurance-style__wrapper__34tR4","icon":"BuyerAssurance-style__icon__1BWOt","text":"BuyerAssurance-style__text__mM6wC","link":"BuyerAssurance-style__link__215wY"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/BuyerAssurance/BuyerAssurance-style.scss
// module id = 3053
// module chunks = 4